module.exports = __webpack_public_path__ + "img/bar-or-club-house.2.020c3ae.jpg";